import { createAction } from 'redux-actions';
import { change } from 'redux-form';
import { map } from 'lodash';
import { batchActions } from 'redux-batched-actions';
import {
  CONTACT_DETAIL_FETCH,
  CONTACT_DETAIL_SUCCESS,
  CONTACT_DETAIL_FAILURE
} from './actionTypes';
import api from '../../services/api';
import { CONTACT_FORM_NAME } from '../ContactForm/constants';

//<<<---CONTACT-DETAIL--->>>
export const contactDetailFetch = createAction(CONTACT_DETAIL_FETCH);
export const contactDetailSuccess = createAction(CONTACT_DETAIL_SUCCESS);
export const contactDetailFailure = createAction(CONTACT_DETAIL_FAILURE);

export const fetchContactDetail = (id, lang) => async dispatch => {
  dispatch(contactDetailFetch());
  try {
    const { data } = await api.get(`contact/${id}/${lang}`);

    const fieldNames = [
      'id',
      'title',
      'description',
      'email',
      'telephone',
      'telephone2',
      'address',
      'other',
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday',
      'sunday'
    ];

    const fieldChangeActions = map(fieldNames, fieldName =>
      change(CONTACT_FORM_NAME, fieldName, data[fieldName])
    );

    dispatch(batchActions(fieldChangeActions));
    dispatch(contactDetailSuccess());
  } catch (error) {
    dispatch(contactDetailFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/ContactDetail/actions.js